import { render, staticRenderFns } from "./CallPackage.vue?vue&type=template&id=61619388"
import script from "./CallPackage.vue?vue&type=script&lang=js"
export * from "./CallPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports